import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const SchoolLeavingCertificateModal = ({
  show,
  handleClose,
  studentId,
  certificateData,
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    generalRegisterNumber: "",
    saralStudentId: "",
    apaarId: "",
    nationalCode: "",
    uidNumber: "",
    fullName: "",
    mothersName: "",
    religionAndCaste: "",
    nationality: "",
    motherTongue: "",
    placeOfBirth: "",
    dateOfBirthWords: "",
    dateOfBirth: "",
    lastSchoolOrCollegeAttended: "",
    dateOfAdmissionAndClass: "",
    progress: "",
    conduct: "",
    dateOfLeaving: "",
    currentStandardAndSinceWhen: "",
    reasonForLeaving: "",
    remarks: "",
    createdBy: localStorage.getItem("userID"),
    updatedBy: localStorage.getItem("userID")
  });

  useEffect(() => {
    if (certificateData) {
      setFormData({
        ...formData,
        ...certificateData,
        dateOfBirth: certificateData.dateOfBirth ? certificateData.dateOfBirth.split("T")[0] : "",
        dateOfLeaving: certificateData.dateOfLeaving ? certificateData.dateOfLeaving.split("T")[0] : "",
        certificateFile: null
      });
    }
  }, [certificateData]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "certificateFile") {
      const file = files[0];
      if (file && file.size > 1024 * 1024) {
        alert("File exceeds 1MB");
        return;
      }
      setFormData((prev) => ({ ...prev, certificateFile: file }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...formData });
    // const data = new FormData();
    // Object.entries(formData).forEach(([key, value]) => {
    //   if (value !== null) data.append(key, value);
    // });
    // data.append("studentId", studentId);
    // onSubmit(data);
  };

 return (
  <Modal show={show} onHide={handleClose} size="xl" centered>
    <Modal.Header closeButton>
      <Modal.Title>LC in Other Language</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form onSubmit={handleSubmit}>
        <Row>
          {[
            ["generalRegisterNumber", "General Register No"],
            ["saralStudentId", "Student ID (SARAL)"],
            ["apaarId", "APAAR ID"],
            ["nationalCode", "National Code (PEN No)"],
            ["uidNumber", "UID (Aadhaar No)"],
            ["fullName", "Name of the student (Full Name)"],
            ["mothersName", "Mother's Name"],
            ["religionAndCaste", "Religion & Caste"],
            ["nationality", "Nationality"],
            ["motherTongue", "Mother Tongue"],
            ["placeOfBirth", "Place of Birth (Village/City, Tal., Zilla, State, Country):"]
          ].map(([name, label], idx) => (
            <Col md={4} key={idx} className="mb-2">
              <Form.Group controlId={name}>
                <Form.Label>{label}</Form.Label>
                <Form.Control
                  type="text"
                  name={name}
                  value={formData[name] || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          ))}

          {/* Move Date of Birth before Date of Birth in Words */}
          <Col md={4} className="mb-2">
            <Form.Group controlId="dateOfBirth">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4} className="mb-2">
            <Form.Group controlId="dateOfBirthWords">
              <Form.Label>Date of Birth in Words</Form.Label>
              <Form.Control
                type="text"
                name="dateOfBirthWords"
                value={formData.dateOfBirthWords || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          {[
            ["lastSchoolOrCollegeAttended", "Last School/College Attended"],
            ["dateOfAdmissionAndClass", "Date of Admission & Class/Stream"],
            ["progress", "Progress"],
            ["conduct", "Conduct"],
            ["currentStandardAndSinceWhen", "Standard in which studying & since when"],
            ["reasonForLeaving", "Reason for Leaving"],
            ["remarks", "Remarks"]
          ].map(([name, label], idx) => (
            <Col md={4} key={idx} className="mb-2">
              <Form.Group controlId={name}>
                <Form.Label>{label}</Form.Label>
                <Form.Control
                  type="text"
                  name={name}
                  value={formData[name] || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          ))}

          <Col md={6}>
            <Form.Group controlId="dateOfLeaving">
              <Form.Label>Date of Leaving the School/College</Form.Label>
              <Form.Control
                type="date"
                name="dateOfLeaving"
                value={formData.dateOfLeaving}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-3">
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" type="submit" className="ms-2">Save</Button>
        </div>
      </Form>
    </Modal.Body>
  </Modal>
);

};

export default SchoolLeavingCertificateModal;
